import { RootState } from "../store";

export const all = (state: RootState) => state.authReducer;

export const isAuthenticated = (state: RootState) => all(state).isAuthenticated;

export const login = (state: RootState) => all(state).login;

export const password = (state: RootState) => all(state).password;

export const currencyCode = (state: RootState) => all(state).currencyCode;

export const ageAgreement = (state: RootState) => all(state).ageAgreement;

export const policyAgreement = (state: RootState) => all(state).policyAgreement;
